<template>
  <div>
    <div v-if="hike">
      <div class="d-flex justify-content-between">
      
          <button @click="addComment" class="btn btn-secondary">
            {{ commentButtonLabel }}
          </button>
        
          <span class="d-flex justify-content-end p-3">
            <select class="custom-select rounded-pill" v-model="selectedOrder">
              <option v-for="order in orderings" :key="order" :value="order" >Sort by {{ order }}</option>
            </select>
          </span>
        
      </div>

      <div class="hike-comments">
        <div id="comments_container">
          <CommentThread 
            v-for="comment in orderedComments"
            :key="comment.id"
            :comment="comment"
            :depth="0"
            :max-depth="4"
            :current-user="user"
            @reply-posted="handleReplyPosted"
            @comment-updated="handleCommentUpdated"
            @comment-deleted="handleCommentDeleted"
          />
        </div>
        <div v-if="hasMoreComments" class="text-center mt-4">
          <button
            class="btn btn-outline-secondary"
            type="button"
            :disabled="loadingMoreComments"
            @click="loadMoreComments"
          >
            <span v-if="loadingMoreComments" class="spinner-border spinner-border-sm mr-2"></span>
            {{ loadingMoreComments ? 'Loading...' : 'Load more comments' }}
          </button>
        </div>
      </div>
    </div>
    <p v-if="hike === null" class="d-flex align-items-center my-3 display-5">
      <span class="spinner-border spinner-border-md mr-2"></span>
      Loading comments...
    </p>
    <div v-if="error">{{ error }}</div>
    <div v-if="hike && hike.comments && hike.comments.length === 0 && !showModal">
      <div class="mt-3">
        <h4><strong>No comments yet!</strong></h4>
        <p>{{ noCommentsMessage }}</p>
      </div>
    </div>
    <CommentDialog ref="commentDialog" />
    <LoadingDialog :show-loading-dialog="newCommentLoading"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { provide, inject, getCurrentInstance } from 'vue';
import CommentThread from './CommentThread.vue';
import CommentDialog from './CommentDialog.vue';
import LoadingDialog from "../../utils/shared_components/LoadingDialog.vue";
import graph_client from '../../utils/graphql/graph_client';

export default {
  components: {
    LoadingDialog,
    CommentThread,
    CommentDialog,
  },
  setup() {
    // Provide GraphQL client to child components
    provide('graphClient', graph_client);
    // Provide store for child components  
    const instance = getCurrentInstance();
    if (instance) {
      provide('store', instance.proxy.$store);
    }
  },
  computed: {
    ...mapState(['hike', 'user', 'error', 'orderings', 'showModal', 'newCommentLoading', 'loadingMoreComments', 'commentsPagination']),
    ...mapGetters(['orderedComments']),
    selectedOrder: {
      get() {
        return this.$store.state.selectedOrder;
      },
      set(value) {
        this.$store.dispatch('setSelectedOrder', value);
      },
    },
    commentableName() {
      return this.$store.state.commentableType === 'Recording' ? 'recording' : 'hike';
    },
    commentButtonLabel() {
      return `Comment on this ${this.commentableName}`;
    },
    noCommentsMessage() {
      return `Be the first to comment on this ${this.commentableName}.`;
    },
    hasMoreComments() {
      return this.commentsPagination?.hasNextPage;
    }
  },
  methods: {
    addComment() {
      this.$store.dispatch('addComment', null);
    },
    
    async handleReplyPosted({ parentCommentId, body }) {
      console.log('[App.vue] handleReplyPosted received:', { parentCommentId, body });
      console.log('[App.vue] parentCommentId type:', typeof parentCommentId);
      // Handle reply directly without showing modal
      try {
        await this.$store.dispatch('submitReply', { parentCommentId, body });
      } catch (error) {
        console.error('Error posting reply:', error);
        alert('Failed to post reply. Please try again.');
      }
    },
    
    handleCommentUpdated(commentId) {
      // Handle comment update - for now just refresh
      console.log('Comment updated:', commentId);
      this.$store.dispatch('fetchHike');
    },
    
    handleCommentDeleted(commentId) {
      // Find the comment and delete it
      const findComment = (comments) => {
        for (const comment of comments) {
          if (comment.id === commentId) return comment;
          if (comment.childComments) {
            const found = findComment(comment.childComments);
            if (found) return found;
          }
        }
        return null;
      };
      
      if (this.hike && this.hike.comments) {
        const comment = findComment(this.hike.comments);
        if (comment) {
          this.$store.dispatch('destroyComment', comment);
        }
      }
    },

    loadMoreComments() {
      this.$store.dispatch('loadMoreComments');
    }
  },
  mounted() {
    this.$store.dispatch('fetchHike');
  },
};
</script>

<style scoped>
  .custom-select{
    background: transparent;
  }
</style>
